import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

function MinhasCobrancas() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [cobrancas, setCobrancas] = useState([]);
  const [carregando, setCarregando] = useState(true);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    carregarCobrancas();
  }, []);

  const carregarCobrancas = async () => {
    try {
      const res = await axios.get(`${API}/financeiro/minhas-cobrancas`, { headers });
      setCobrancas(res.data);
    } catch (err) { console.error(err); }
    setCarregando(false);
  };

  const statusCor = (status) => {
    if (status === 'pago') return { bg: '#E1F5EE', cor: '#0F6E56', texto: '✅ Pago' };
    if (status === 'atrasado') return { bg: '#FCEBEB', cor: '#A32D2D', texto: '⚠️ Atrasado' };
    if (status === 'cancelado') return { bg: '#f0f0f0', cor: '#666', texto: '❌ Cancelado' };
    return { bg: '#FAEEDA', cor: '#633806', texto: '⏳ Pendente' };
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />

      <div style={{
        background: '#1D9E75', padding: '0 24px', height: '60px',
        display: 'flex', alignItems: 'center', gap: '16px',
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500,
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
      }}>
        <button onClick={() => setSidebarAberta(!sidebarAberta)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '22px', color: 'white' }}>
          {sidebarAberta ? '✕' : '☰'}
        </button>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>💳 Minhas Cobranças</span>
      </div>

      <div style={{ marginTop: '60px', padding: '24px' }}>
        {carregando ? (
          <div style={{ textAlign: 'center', padding: '48px', color: '#999' }}>⏳ Carregando...</div>
        ) : cobrancas.length === 0 ? (
          <div style={{ background: 'white', borderRadius: '12px', padding: '48px', textAlign: 'center', color: '#999', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>💳</div>
            <div style={{ fontSize: '16px', fontWeight: '500' }}>Nenhuma cobrança encontrada</div>
            <div style={{ fontSize: '13px', marginTop: '8px' }}>Suas cobranças aparecerão aqui</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {cobrancas.map((c, i) => {
              const st = statusCor(c.status);
              const atrasado = c.status === 'pendente' && new Date(c.vencimento) < new Date();
              return (
                <div key={i} style={{
                  background: 'white', borderRadius: '12px', padding: '20px',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                  borderLeft: `4px solid ${atrasado ? '#E24B4A' : st.cor}`
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontSize: '15px', fontWeight: '600', color: '#333', marginBottom: '4px' }}>
                        {c.descricao || 'Cobrança'}
                      </div>
                      <div style={{ fontSize: '13px', color: '#666' }}>
                        Vencimento: {new Date(c.vencimento).toLocaleDateString('pt-BR')}
                      </div>
                      {c.data_pagamento && (
                        <div style={{ fontSize: '12px', color: '#1D9E75', marginTop: '2px' }}>
                          Pago em: {new Date(c.data_pagamento).toLocaleDateString('pt-BR')}
                        </div>
                      )}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: '20px', fontWeight: '700', color: '#1D9E75', marginBottom: '8px' }}>
                        R$ {parseFloat(c.valor).toFixed(2)}
                      </div>
                      <span style={{ background: st.bg, color: st.cor, padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500' }}>
                        {atrasado ? '⚠️ Vencido' : st.texto}
                      </span>
                    </div>
                  </div>

                  {(c.status === 'pendente' || atrasado) && c.link_pagamento && (
                    <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid #f0f0f0' }}>
                      <a href={c.link_pagamento} target="_blank" rel="noopener noreferrer"
                        style={{ display: 'inline-block', background: '#1D9E75', color: 'white', borderRadius: '8px', padding: '10px 20px', textDecoration: 'none', fontWeight: '600', fontSize: '13px' }}>
                        💳 Pagar Agora
                      </a>
                    </div>
                  )}

                  {(c.status === 'pendente' || atrasado) && !c.link_pagamento && (
                    <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid #f0f0f0', fontSize: '13px', color: '#999' }}>
                      Entre em contato para obter o link de pagamento
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default MinhasCobrancas;